import api from "@/services/axios.js";
import type { ZipFilesListResponse } from "../../types.ts";
import { ZipFileStatus } from "../../types.ts";

export const getZipFiles = (page: number, pageSize: number, name: string) =>
  api.get<ZipFilesListResponse>("/api/AdminVerification/zip-files", {
    params: { Name: name || undefined, Page: page, PageSize: pageSize, Status: ZipFileStatus.Uploaded },
  });
